module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/dJoQ2p/tc-custom/9781612436555.jpg?1728253841047",
      "alt": "This image is the cover for the book Gastroparesis Healing Diet"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Gastroparesis Healing Diet\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("From a certified nutrition consultant, a customizable approach to overcoming symptoms of gastroparesis through a personalized nutritional program.")]), _c('br'), _c('br'), _vm._v("With no identifiable cause, no known cure and life-sapping symptoms, gastroparesis can make you feel helpless. But you’re not! "), _c('i', [_vm._v("The Gastroparesis Healing Diet")]), _vm._v(" empowers you to tame your symptoms by taking total control of your diet."), _c('br'), _c('br'), _vm._v("Featuring a step-by-step program that you personalize for your specific needs, this helpful handbook offers:"), _c('br'), _c('br'), _vm._v("• A guided elimination diet for identifying triggers"), _c('br'), _c('br'), _vm._v("• Carefully formulated yet amazingly delicious recipes"), _c('br'), _c('br'), _vm._v("• A plan to stock your pantry with nutrient-dense foods"), _c('br'), _c('br'), _vm._v("• Tips and tricks for dealing with flare-ups"), _c('br'), _c('br'), _vm._v("• Shared stories from others with gastroparesis"), _c('br'), _c('br'), _vm._v("• Advice on reducing stress and finding support\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Tammy Chang\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Ulysses Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0